import createConverter from './lib/create_converter';
import User from 'models/user';

export default createConverter(User);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/user_converter.js